var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _ellipse2, _polyline, _path10, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvSafeDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.a{stroke:#81949c;}.a,.b{stroke-linecap:round;stroke-linejoin:round;}.b{stroke:#ff5a00;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.428,21.744h8.128A4.127,4.127,0,0,1,79.045,23.7l10.2,16.214H67.428Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.12,64.008a7.336,7.336,0,0,0-2.29-5.218,7.311,7.311,0,0,0-9.9,0,7.336,7.336,0,0,0-2.293,5.221H67.428v-24.1H89.154l7.486,3.632a5.007,5.007,0,0,1,2.86,4.49V62a2.039,2.039,0,0,1-2.069,2.008Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.321,56.991v-.04l28.108,0v7.055H47.119A7.086,7.086,0,0,0,40,56.953,3.292,3.292,0,0,0,39.321,56.991Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.857,71.152a16.831,16.831,0,0,0,.325-1.726,16.614,16.614,0,0,0,.13-1.717l.009-10.718a6.891,6.891,0,0,1,7.8,6.1c.554,3.855-2.745,7.495-6.088,8.093A4.86,4.86,0,0,1,38.857,71.152Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.32,56.951c0-4,0-7.991,0-11.987-1.289-.261-2.622-.522-3.911-.784-1.735-.354-3.61-.782-5.594-1.382-2.027-.613-3.881-1.24-5.553-1.922-1.37-.561-2.983-1.188-4.353-1.749L16.07,40.67c-.972.409-1.966.766-2.957,1.122V11.835H67.428V56.953Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.3,18.371H62.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.45,24.343H62.506"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.324,43.935h5.128"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 80.886,
    cy: 64.062,
    rx: 4.133,
    ry: 4.118
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.331,59.988a1.991,1.991,0,0,1,.69-.066,4.087,4.087,0,1,1,0,8.173,2.139,2.139,0,0,1-.737-.061"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 80.886,
    cy: 64.062,
    rx: 7.233,
    ry: 7.206
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "10.765 62.871 19.349 70.611 31.198 56.68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.5,44.964,4.345,44.2A64.4,64.4,0,0,0,15.75,40.8l4.161-1.672L24.072,40.8a64.385,64.385,0,0,0,11.4,3.4l3.846.767V67.149q0,13.413-19.411,21.016Q.5,80.416.5,67.149Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: -1087.864,
    y: -414.744,
    width: 1260,
    height: 1962
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvSafeDelivery);
export default __webpack_public_path__ + "static/media/sv-safe-delivery.c1071d68d281a5c0344b4216dd55e2cf.svg";
export { ForwardRef as ReactComponent };